<template>
  <div class="log-container">
    <!-- 查询栏 -->
    <div class="query-nav">
      <el-form ref="queryFormRef" :model="queryForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-form-item prop="name" label="日志名称">
              <el-input v-model.trim="queryForm.name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="opType" label="操作类型">
              <el-select v-model="queryForm.opType" placeholder="请选择">
                <el-option
                  v-for="item in actionTypeList"
                  :key="item.code"
                  :label="item.value"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="success" label="是否成功">
              <el-select v-model="queryForm.success" placeholder="请选择">
                <el-option label="是" value="Y"></el-option>
                <el-option label="否" value="N"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" style="margin-right: 6px;" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-col>
          <el-col :span="6">
            <el-button
              type="danger"
              style="float: right;"
              :disabled="!multiSelectedList.length"
              @click="confirmDelete"
            >清空日志</el-button>
            <el-button
              type="success"
              style="float: right; margin-right: 16px;"
              :loading="exportBtnLoading"
              @click="handleExportLog"
            >{{exportBtn}}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <div class="table">
      <el-table
        :data="actionLogList"
        v-loading="tableLoading"
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="60" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="name" label="日志名称" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="visType" label="操作类型" align="center" :resizable="false">
          <template slot-scope="{ row }">
            <span>{{getActionTypeName(row.opType)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="success" label="是否成功" align="center" :resizable="false">
          <template slot-scope="{ row }">
            <span>{{row.success === 'Y' ? '是' : '否'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ip" label="IP" align="center"></el-table-column>
        <el-table-column prop="url" label="请求地址" align="center"></el-table-column>
        <el-table-column prop="opTime" label="操作时间" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="account" label="操作人" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{ row }">
            <el-tooltip class="item" effect="dark" content="查看详情" placement="top">
              <i class="iconfont iconcaozuo-8chakanxiangqing_1" @click="handleViewDetail(row)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页区域 -->
    <div class="page">
      <el-pagination
        :total="total"
        :current-page="queryForm.pageNo"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 30, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <!-- 查看操作日志详情对话框 -->
    <el-dialog title="日志详情" :visible.sync="logDialogVisible" width="900px">
      <el-form label-width="auto">
        <el-row>
          <el-col :span="12">
            <el-form-item label="方法名称">
              <span>{{ logDetail.methodName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址">
              <span>{{ logDetail.url }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="浏览器">
              <span>{{ logDetail.browser }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作系统">
              <span>{{ logDetail.os }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="类名称">
              <span>{{ logDetail.className }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="具体消息">
              <span>{{ logDetail.message }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="请求参数">
              <span>{{ logDetail.param }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="返回结果">
              <span>{{ logDetail.result }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import commApi from 'api/common.js';
import logApi from 'api/home/log-management.js';

export default {
  data() {
    return {
      total: 0,
      queryForm: {
        name: '',
        opType: '',
        success: '',
        pageSize: 10,
        pageNo: 1
      },
      actionTypeList: [],
      tableLoading: true,
      actionLogList: [],
      multiSelectedList: [],
      exportBtnLoading: false,
      exportBtn: '导出数据',
      logDetail: {},
      logDialogVisible: false
    };
  },
  created() {
    this.getActionTypeListData();
    this.getActionLogListData();
  },
  methods: {
    // 获取操作类型下拉
    getActionTypeListData() {
      commApi.getDictType('op_type').then(res => {
        if (res.data.code === 200) {
          this.actionTypeList = res.data.data;
        }
        // else {
        //   this.$message.error(res.data.message);
        // }
      });
    },
    // 获取操作类型 name
    getActionTypeName(code) {
      let ret = '';
      this.actionTypeList.forEach(item => {
        if (item.code == code) {
          ret = item.value;
          return;
        }
      });
      return ret;
    },
    // 获取操作日志列表
    getActionLogListData() {
      this.tableLoading = true;
      logApi
        .getActionLogList(this.queryForm)
        .then(res => {
          if (res.data.code === 200) {
            this.total = res.data.data.totalRows;
            this.actionLogList = res.data.data.rows;
          }
          // else {
          //   this.$message.error(res.data.message);
          //   this.tableLoading = false;
          // }
          this.tableLoading = false;
        })
        .catch(err => {
          this.tableLoading = false;
        });
    },
    // 搜索
    handleSearch() {
      this.queryForm.pageNo = 1;
      this.getActionLogListData();
    },
    // 重置
    handleReset() {
      this.$refs.queryFormRef.resetFields();
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = 10;
      this.getActionLogListData();
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = val;
      this.getActionLogListData();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNo = val;
      this.getActionLogListData();
    },
    // 表格选择事件
    handleSelectionChange(selectedList) {
      this.multiSelectedList = [];
      this.multiSelectedList = selectedList.map(item => {
        return item.id;
      });
    },
    // 确认删除所选日志
    confirmDelete() {
      this.$confirm('确定清空所选日志？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          logApi
            .postDeleteActionLog({
              idList: this.multiSelectedList
            })
            .then(res => {
              if (res.data.code === 200) {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.handleSearch();
              }
              // else {
              //   this.$message.error(res.data.message);
              // }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消删除'
          });
        });
    },
    // 导出日志
    handleExportLog() {
      this.exportBtnLoading = true;
      this.exportBtn = '导出中...';
      logApi
        .getExportActionLog(this.queryForm)
        .then(res => {
          // if (res.status !== 200) {
          //   this.exportBtnLoading = false;
          //   this.exportBtn = '导出数据';
          //   this.$message({
          //     type: 'error',
          //     message: '导出数据失败'
          //   });
          //   return;
          // }

          let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
          let h = JSON.stringify(res.headers);
          let j = JSON.parse(h);
          let fileName = decodeURI(j['content-disposition'].split('attachment; filename=')[1]);
          fileName = fileName.replace(/\"/g, '');
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          // debugger;
          link.click();
          window.URL.revokeObjectURL(link.href);
          this.exportBtnLoading = false;
          this.exportBtn = '导出数据';
          this.$message({
            type: 'success',
            message: '导出数据成功'
          });
        })
        .catch(err => {
          this.exportBtnLoading = false;
          this.exportBtn = '导出数据';
        });
    },
    // 查看详情
    handleViewDetail(row) {
      this.logDetail = row;
      this.logDialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
.log-container {
  padding: 16px;

  .query-nav {
    height: 40px;
  }

  .page {
    margin: 16px 0;
    float: right;
  }
}

.iconfont {
  font-size: 28px;
  color: #409dff;
  cursor: pointer;
}
</style>
